import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter, Redirect, Switch, Route, withRouter } from 'react-router-dom';
import { Segment, Dimmer, Loader, Image } from 'semantic-ui-react';
import Firebase from './Firebase';
import Header from './views/Common/Header/Header';
const Routes = require('./routes');

function App(props) {
  const [firebaseInitialized, setFirebaseInitialized] = useState(false);

  useEffect(() => {
    Firebase.isInitialized().then((val) => {
      if (val == null) {
        val = true;
      }
      setFirebaseInitialized(val);
    });
  });

  return firebaseInitialized ? (
    <div>
      <Header history={props.history} />
      <div className='page-body-content'>
        <BrowserRouter>
          <Suspense
            fallback={
              <div
                style={{
                  textAlign: 'center',
                  height: '80vh',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <div>
                  <Segment
                    style={{
                      height: '100vh',
                    }}
                  >
                    <Dimmer active inverted>
                      <Loader size='large'>Loading</Loader>
                    </Dimmer>
                  </Segment>
                </div>
              </div>
            }
          >
            <Switch>
              {Routes.default.map((route, index) =>
                !Firebase.isLoggedIn() && route.requireAuth ? (
                  <Redirect to={process.env.PUBLIC_URL + '/login'} />
                ) : (
                  <Route exact key={index} path={process.env.PUBLIC_URL + route.slug} component={withRouter(route.component)} />
                )
              )}
            </Switch>
          </Suspense>
        </BrowserRouter>
      </div>
    </div>
  ) : (
    <div>
      <Segment
        style={{
          height: '100vh',
        }}
      >
        <Dimmer active inverted>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
      </Segment>
    </div>
  );
}

export default App;
